import { createContext } from 'react';

/** @internal */
export const MenuPortalOwnerContext = createContext<string | undefined>(
  undefined,
);
